import { httpInstance } from '../../../core';

export const insightUseCaseDefaults = {
  // @agentsNote Insight-created use cases use a fixed owner that is intentionally not shown in the modal.
  ownerName: 'M.Balodis (c)',
  ownerEmail: 'm.balodis@avanade.com',
  area: 'Operations',
  clientGroup: 'Other',
  businessFunction: 'Delivery',
  sourceSystem: 'Linklaters (DevOps)',
  stage: 'submitted',
};

interface InsightUseCaseDraft {
  title: string;
  ideaDescription: string;
}

interface InsightUseCaseCreationResponse {
  jobId?: string;
  status?: string;
  useCase?: { id?: string | number };
}

/** @agentsNote AI Hub uses a separate host; the usual portal POST helper targets the main portal API and suppresses HTTP errors. */
export const createInsightUseCase = async (draft: InsightUseCaseDraft): Promise<InsightUseCaseCreationResponse> => {
  const baseUrl = process.env.REACT_APP_AI_HUB_API_BASE_URL || process.env.REACT_APP_WSP_API_BASE_URL || '';
  const response = await httpInstance.post(
    `${baseUrl}/api/ai/ukdc/use-cases/create-and-qualify-from-ado`,
    { ...draft, ...insightUseCaseDefaults },
  );
  const result = response.data as InsightUseCaseCreationResponse | null;
  const status = typeof result?.status === 'string' ? result.status.toLowerCase() : '';
  const useCaseId = result?.useCase?.id;

  // @agentsNote A successful HTTP response alone is not proof of creation; retain the form if the job or created use-case identifier is missing.
  if (!result || Array.isArray(result) || status === 'failed' || status === 'error' ||
    (!result.jobId && (useCaseId === undefined || useCaseId === null || `${useCaseId}`.trim() === ''))) {
    throw new Error('Could not confirm use case creation. Check AI Hub before trying again.');
  }

  return result;
};
